import { appraisalSurchargesApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const APPRAISAL_SURCHARGES_ACTION_TYPE = createNamedActions('appraisalSurcharges', {
  GET_APPRAISAL_SURCHARGES: 'GET_APPRAISAL_SURCHARGES',
  CREATE_APPRAISAL_SURCHARGE: 'CREATE_APPRAISAL_SURCHARGE',
  UPDATE_APPRAISAL_SURCHARGE: 'UPDATE_APPRAISAL_SURCHARGE',
  DELETE_APPRAISAL_SURCHARGE: 'DELETE_APPRAISAL_SURCHARGE',
});

const appraisalSurchargeSchema = new schema.Entity(
  'data',
  {},
  { idAttribute: entity => entity.appraisalSurchargeId || entity.id },
);

export const getAppraisalSurchargesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await appraisalSurchargesApi.getAppraisalSurcharges(params);

  return dispatch({
    type: APPRAISAL_SURCHARGES_ACTION_TYPE.GET_APPRAISAL_SURCHARGES,
    payload: normalize(data, [appraisalSurchargeSchema]).entities.data,
  });
});

export const createAppraisalSurchargeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await appraisalSurchargesApi.createAppraisalSurcharge(params);

  return dispatch({
    type: APPRAISAL_SURCHARGES_ACTION_TYPE.CREATE_APPRAISAL_SURCHARGE,
    payload: data,
  });
});

export const updateAppraisalSurchargeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await appraisalSurchargesApi.updateAppraisalSurcharge(params);

  return dispatch({
    type: APPRAISAL_SURCHARGES_ACTION_TYPE.UPDATE_APPRAISAL_SURCHARGE,
    payload: data,
  });
});

export const deleteAppraisalSurchargeAction = catchAsyncActionError(params => async dispatch => {
  await appraisalSurchargesApi.deleteAppraisalSurcharge(params);

  return dispatch({
    type: APPRAISAL_SURCHARGES_ACTION_TYPE.DELETE_APPRAISAL_SURCHARGE,
    meta: params,
  });
});
